module.exports = __webpack_public_path__ + "img/sankaku_90_blue.0f550220.png";